module.exports = __webpack_public_path__ + "static/media/card-email-br.d54cc44f.png";